import Svg, { Path, type SvgProps } from 'react-native-svg'

export function AccountIcon(props: SvgProps) {
  return (
    <Svg width={33} height={32} viewBox="0 0 33 32" fill="none" {...props}>
      <Path
        d="M25.4998 4H6.83317C5.36041 4 4.1665 5.19391 4.1665 6.66667V25.3333C4.1665 26.8061 5.36041 28 6.83317 28H25.4998C26.9726 28 28.1665 26.8061 28.1665 25.3333V6.66667C28.1665 5.19391 26.9726 4 25.4998 4Z"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M4.1665 11.9999C4.1665 11.2927 4.44746 10.6144 4.94755 10.1143C5.44765 9.6142 6.12593 9.33325 6.83317 9.33325H25.4998C26.2071 9.33325 26.8854 9.6142 27.3855 10.1143C27.8856 10.6144 28.1665 11.2927 28.1665 11.9999"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M4.1665 14.6667H8.1665C9.23317 14.6667 10.2998 15.0667 10.9665 15.8667L12.4332 17.0667C14.5665 19.2001 17.8998 19.2001 20.0332 17.0667L21.4998 15.8667C22.1665 15.2001 23.2332 14.6667 24.2998 14.6667H28.1665"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
